<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="title"
                :back_title="back_title"
                :link="link"
            />
            <div class="page">
                <div v-if="Object.keys(this.defects).length > 0" class="mt-3">
                    <h5 class="my-3">Неисправленные дефекты</h5>
                    <div class="d-flex justify-content-around gap-3 flex-wrap">
                        <div class="item_title col-12 col-md-5 mb-0"
                            v-for="defect in this.defects"
                            :key="defect.id"
                            @click="next(defect.id)"
                        >
                            <!-- Карточка с нарушениями -->
                            <div class="gn_row d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column">
                                    <div class="gn_worker_name text-start">
                                        <fa class="icon pe-1 text-black-50" icon="list-check"></fa>
                                        {{ defect.name }}
                                    </div>
                                </div>
                                <h6 class="gn_defects_count">
                                    <span class="badge rounded-pill text-bg-danger">{{ defect.count }}</span>
                                </h6>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="text_end" v-else>
                    <div class="item_title text-center border-green mb-4">
                        Все несоответствия устранены
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from "axios";
import spinner from '../../../components/Spinner';
import BreadCrumbs from "../../../Page/BreadCrumbs";

export default {
    name: "TSMDefectsListPage",
    components: {
        spinner, BreadCrumbs
    },
    data(){
        return {
            isLoading: false,
            defects: {},
            item: '',
            breadCrumbs: true,
            title: 'Группы несоответствий',
            back_title: 'Несоответствия',
            link: 'select-defects',
        }
    },
    created() {
        this.getDefects();
    },
    methods:{
        next(id){
            this.$router.push(`/tsm-defects/${id}`);
        },
        async getDefects(){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get('/api/admin/tsm/get/defects', config);
                this.user = response.data.data.user;
                this.defects = response.data.data.checkings;
            } catch (e) {
                console.log(e);
            }finally {
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>

</style>
